import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const chapters = [{
  num: '01',
  title: 'Por qué los agentes te necesitan',
  desc: 'Entiende el dolor del agente y cómo tu rapidez para contestar mensajes se convierte en su mejor inversión.'
}, {
  num: '02',
  title: 'Tu perfil profesional',
  desc: 'Cómo configurar tu WhatsApp Business y limpiar tus redes sociales para proyectar confianza sin necesidad de un título.'
}, {
  num: '03',
  title: 'Cómo encontrar clientes',
  desc: 'Estrategias exactas para buscar en grupos de Facebook y el mensaje directo (DM) exacto para ofrecer tus servicios.'
}, {
  num: '04',
  title: 'El guion de atención',
  desc: 'Qué decir exactamente: desde el saludo inicial, cómo filtrar al cliente y cómo cerrar la cita en la agenda del agente.'
}, {
  num: '05',
  title: 'Cómo cobrar por tu trabajo',
  desc: 'Los tres modelos de cobro comprobados y los métodos de pago más seguros para recibir tu dinero en Estados Unidos.'
}];
export function ChaptersSection() {
  return <section className="py-24 bg-white" data-id="element-9">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-11">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-cream mb-4" data-id="element-12">
            <BookOpen className="w-6 h-6 text-gold" data-id="element-13" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-14">
            ¿Qué Aprenderás en Esta Guía?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-15">
            Un paso a paso directo al grano, sin relleno, diseñado para que
            puedas empezar a ofrecer tus servicios esta misma semana.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-16">
          {chapters.map((chapter, index) => <motion.div key={chapter.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`bg-cream/30 border border-cream-dark p-8 rounded-xl hover:shadow-md transition-shadow ${index === chapters.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto w-full' : ''}`} data-id="element-17">
              <div className="flex items-start gap-6" data-id="element-18">
                <span className="text-4xl font-serif font-bold text-gold/40 leading-none" data-id="element-19">
                  {chapter.num}
                </span>
                <div data-id="element-20">
                  <h3 className="text-xl font-bold text-navy mb-3" data-id="element-21">
                    {chapter.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-22">
                    {chapter.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}